/**
 * The Social video currently on screen.
 *
 * The feed writes here as the viewer scrolls so AI tools can answer
 * "what am I watching?" without reaching into component state.
 */

export interface CurrentSocialVideo {
  id: string;
  caption: string | null;
  creator: string | null;
  creatorHandle: string | null;
  platform: string | null;
  postedAt: string | null;
  originalUrl: string;
  position: number;
  total: number;
}

let current: CurrentSocialVideo | null = null;

export function setCurrentSocialVideo(video: CurrentSocialVideo | null): void {
  current = video;
}

export function getCurrentSocialVideo(): CurrentSocialVideo | null {
  return current;
}
